import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';

/** Sticky action bar shown at the bottom of an admin table when rows are
 * selected. Consumers pass:
 *   count      — number of rows selected
 *   onClear    — callback to deselect all
 *   actions    — [{ key, label, icon: Component, onClick, variant?: 'danger'|'default' }]
 *   testIdPrefix — used to generate stable data-testids
 */
const BulkActionBar = ({ count, onClear, actions = [], testIdPrefix = 'bulk' }) => {
  if (count === 0) return null;
  return (
    <div
      data-testid={`${testIdPrefix}-action-bar`}
      className="jw-card sticky bottom-4 z-30 mt-3 px-4 py-3 flex items-center gap-2 flex-wrap shadow-2xl"
      style={{
        background: 'var(--jw-bg-alt)',
        borderColor: 'var(--jw-border)',
      }}
    >
      <div className="flex items-center gap-2 pe-3 border-e" style={{ borderColor: 'var(--jw-border)' }}>
        <span className="text-sm font-semibold" data-testid={`${testIdPrefix}-selected-count`}>
          {count} selected
        </span>
        <Button size="icon" variant="ghost" onClick={onClear} data-testid={`${testIdPrefix}-clear-selection`} title="Clear selection">
          <X className="w-4 h-4" />
        </Button>
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        {actions.map((a) => {
          const Icon = a.icon;
          return (
            <Button
              key={a.key}
              size="sm"
              onClick={a.onClick}
              data-testid={`${testIdPrefix}-action-${a.key}`}
              disabled={a.disabled}
              className={
                a.variant === 'danger'
                  ? 'bg-rose-500/15 text-rose-200 border border-rose-400/30 hover:bg-rose-500/25 h-9'
                  : 'jw-btn-gloss-ghost h-9'
              }
            >
              {Icon && <Icon className="w-4 h-4 me-1" />}
              {a.label}
            </Button>
          );
        })}
      </div>
    </div>
  );
};

export default BulkActionBar;
